module.exports = __webpack_public_path__ + "img/folder-dont.67a674a7.svg";